import React from "react";

export enum DataType {
  LIST = "list",
  DETAIL = "detail"
}

export interface ResultsProps {
  children: React.ReactNode;
  type: DataType;
}
